// extracted by mini-css-extract-plugin
export default {"questionBlock":"Question_questionBlock__o4Zpq","question":"Question_question__TM3KY","questionBg":"Question_questionBg__S+96q"};